var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsErrorToast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L14.9 16.31C13.55 17.37 11.85 18 10 18zm6.31-3.1L5.1 3.69C6.45 2.63 8.15 2 10 2c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z",
    transform: "translate(-900 -100) translate(886 88) translate(14 12)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsErrorToast);
export default __webpack_public_path__ + "static/media/icons-error-toast.f8aa507331cea77cb313d51fed360612.svg";
export { ForwardRef as ReactComponent };